<template>
    <div>
        <modal-building v-if="showModal"
                        v-bind:content="{mappedBuilding: mappedBuilding}"
        ></modal-building>
<div class="row">
    <div class="col"> <hr></div>

</div>
        <div class="row" v-show="CHECK_ROLE_CARD(1)">
            <div class="col-md-8">
                <div class="row">
                    <div class="col-md-2">
                        <img src="/img/icons/mercatolibero_icon.svg" class="img-fluid">
                    </div>
                    <div class="col-md-10">
                        <div class="card  abtg__default-card abtg__default-card-border">
                            <div class="card-head">
                                <header>{{$t('operation.title_card')}}</header>
                                <div class="abtg__header_popover">
                                    <popover module="custom" content="buildingData" color="grey"
                                             position="right"></popover>
                                </div>

                                <div class="tools" style="margin-bottom: 0 !important;">
                                    <a @click="closeOrOpen()">
                                        <button class="btn btn-default  shadow-none abtg__btn-tool">
                            <span v-if="!closedOperation">
                            <i
                                    class="fas fa-lock-open"></i> {{$t('operation.in_corso')}}
                            </span>
                                            <span v-else>
                            <i
                                    class="fas fa-lock"></i> {{$t('operation.conclusa')}}
                           </span>
                                        </button>

                                    </a>
                                    <a @click="showHideModal()"
                                       class="btn btn-default abtg__btn-star shadow-none abtg__btn-tool">
                                 <span v-if="id > 0">
                                {{$t('operation.modifica')}}
                                </span>
                                        <span v-else>
                                    {{$t('operation.nuovo')}}
                                </span>
                                    </a>


                                </div>
                            </div>
                            <div class="card-body ">

                                <p><span class="  abtg__text-abtg">{{$t('valutation.label_city')}}:</span> <strong><span
                                        class="abtg__color-black-label">{{mappedBuilding.citta}}</span></strong> <br>
                                    <span class="abtg__text-abtg">{{$t('valutation.label_zone')}}:</span> <strong><span
                                            class="abtg__color-black-label">{{DASH_IF_EMPTY(mappedBuilding.zone)}}</span></strong>
                                    |
                                    <span class="abtg__text-abtg">{{$t('valutation.label_macrozone')}}:</span>
                                    <strong><span
                                            class="abtg__color-black-label">{{DASH_IF_EMPTY(mappedBuilding.macrozone)}}</span></strong>
                                    |
                                    <span class="abtg__text-abtg">{{$t('valutation.label_microzone')}}:</span>
                                    <strong><span
                                            class="abtg__color-black-label">{{DASH_IF_EMPTY(mappedBuilding.microzone)}}</span></strong>
                                </p>
                                <hr class="abtg__hr-narrow">

                                <div class="row">
                                    <div class="col-md-8">
                                        <p><span class="abtg__label-small">{{$t('valutation.label_address')}}</span><br>
                                            <strong><span
                                                    class="abtg__color-black-label">{{mappedBuilding.via}}</span></strong>
                                        </p>
                                    </div>

                                    <div class="col-lg-2">
                                        <p><span
                                                class="abtg__label-small">{{$t('operation.overview_label_mq')}}</span><br>
                                            <strong><span
                                                    class="abtg__color-black-label">{{mappedBuilding.mq}}</span></strong>
                                        </p>
                                    </div>
                                    <div class="col-lg-2">
                                        <p><span
                                                class="abtg__label-small">{{$t('operation.overview_label_value')}}</span><br>
                                            <strong><span
                                                    class="abtg__color-black-label">{{mappedBuilding.prezzo}}</span></strong>
                                        </p>
                                    </div>


                                </div>

                                <hr class="abtg__hr-narrow">
                                <div class="row">


                                    <div class="col-lg-2">
                                        <p><span
                                                class="abtg__label-small">{{$t('valutation.label_room')}}</span><br><strong><span
                                                class="abtg__color-black-label">{{mappedBuilding.locali}}</span></strong>
                                        </p>
                                    </div>
                                    <div class="col-lg-2">
                                        <p><span class="abtg__label-small">{{$t('valutation.label_piano')}}</span><br><strong><span
                                                class="abtg__color-black-label">{{mappedBuilding.piano}}</span></strong>
                                        </p>
                                    </div>
                                    <div class="col-lg-2">
                                        <p><span class="abtg__label-small">{{$t('valutation.label_lift')}}</span><br>
                                            <strong><span
                                                    class="abtg__color-black-label">{{mappedBuilding.ascensori}}</span></strong>
                                        </p>
                                    </div>
                                    <div class="col-lg-2">
                                        <p><span
                                                class="abtg__label-small">{{$t('valutation.label_bathroom')}}</span><br>
                                            <strong><span
                                                    class="abtg__color-black-label">{{mappedBuilding.bagni}}</span></strong>
                                        </p>
                                    </div>
                                    <div class="col-lg-4"><p>
                                        <span class="abtg__label-small">{{$t('valutation.label_renovation')}}</span><br>
                                        <strong><span
                                                class="abtg__color-black-label">{{mappedBuilding.ristrutturazione}}</span></strong>
                                    </p></div>
                                </div>
                                <hr class="abtg__hr-narrow">
                                <div class="row">
                                    <div class="col-lg-4"><p><span class="abtg__label-small">{{$t('valutation.label_date')}}</span><br><strong><span
                                            class="abtg__color-black-label">{{mappedBuilding.data}}</span></strong></p>
                                    </div>

                                    <div class="col-lg-4"><p><span class="abtg__label-small">{{$t('valutation.label_link')}}</span><br>
                                        <strong><a target="_blank"
                                                   :href="mappedBuilding.myLink"
                                                   v-if="mappedBuilding.myLink"
                                        >
                                           {{$t('valutation.label_link_l')}} </a></strong></p></div>

                                  <div class="col-lg-4"><p><span class="abtg__label-small">{{$t('valutation.label_mapping_link')}}</span><br>
                                        <strong><router-link :to="{name: 'N_Mapping', params: {zone_id: mappedBuilding.zone_id}}"
                                                   v-if="mappedBuilding.zone_id">
                                           {{$t('valutation.label_mapping_link_l')}}</router-link></strong></p></div>
                                </div>


                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-md-4">
                <div class="row">
                    <div class="col">
                        <div class="card abtg__default-card abtg__default-card-border">
                            <div class="card-head ">
                                <div class="abtg__small-card-header"><i class="fas fa-circle"></i> <span
                                        class="abtg__small-card-label">ROI ({{$t('valutation.label_consuntivo')}})</span></div>
                            </div>
                            <div class="card-body no-padding ">
                                <div class="abtg__card-text-number" v-if="roi_">{{roi_}}%</div>
                                <div class="progress">
                                    <div class="progress-bar" style="width:100%;"></div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card abtg__default-card abtg__default-card-border">
                            <div class="card-head ">
                                <div class="abtg__small-card-header"><i class="fas fa-circle"></i> <span
                                        class="abtg__small-card-label">ROE ({{$t('valutation.label_consuntivo')}})</span></div>
                            </div>
                            <div class="card-body no-padding ">
                                <div class="abtg__card-text-number" v-if="roe_">{{roe_}}%</div>
                                <div class="progress">
                                    <div class="progress-bar" style="width:100%;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="card abtg__default-card abtg__default-card-border">

                            <div class="card-body no-padding ">
                                <p><span class="abtg__label-small">Note</span><br>
                                    <span class="abtg__label-small-text">{{mappedBuilding.note}}</span>
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>
<script>
    import {mixin} from '../../helpers/helper'
    import {roles} from '../../helpers/roles';
    import {Money} from 'v-money';
    import modalBuilding from './modal_building_card';
    import {createHelpers} from 'vuex-map-fields';
    import Popover from '../commons/popover';


    const {mapFields} = createHelpers({
        getterType: 'custom/getField',
        mutationType: 'custom/updateField',
    });

    export default {
        mixins: [mixin, roles],
        components: {Money, modalBuilding, Popover},
        props: ['id', 'customId', 'page', 'type'],
        data: function () {
            return {}
        },

        computed: {
            ...mapFields(['showModal', 'mappedBuilding', 'buildingId', 'roi_', 'roe_', 'closedOperation']),
        },

        created: function () {
            this.$store.dispatch('custom/clearForm');
            this.$store.dispatch('custom/checkId', this.$route.params);
            if (this.id === undefined && this.customId === undefined) {
                this.showHideModal();
            } else if (this.id !== undefined && this.customId != undefined) {
                this.$store.dispatch('custom/addTeamToOperation', {resourceId: this.id, type: 3});
            }
            this.$store.dispatch('custom/isOperationClosed', {resourceId: this.id, type: this.type});

            this.track();
        },

        methods: {
            track: function () {
                this.$store.dispatch('track/create', 'Mercato Libero', {root: true});
            },
            onSubmit: function () {
                this.$store.dispatch('custom/saveData');
            },

            showHideModal: function () {
                this.$store.dispatch('custom/showHideModal');
            },
            closeOrOpen: function () {
                this.$store.dispatch('custom/closeOrOpen', {
                    resourceId: this.page,
                    type: this.type
                });
            }
        }
    }
</script>
